import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

class ThemeProvider extends React.Component {
  render() {
    const { direction } = this.props;

    const theme = createMuiTheme({
      direction,
      isRtl: true,
      palette: {
        primary: { main: '#f50057' },
        secondary: { main: '#e0e0c8' }
      },
      typography: {
        fontSize: 15
      },
      overrides: {
        MuiButton: {
          contained: {
            textTransform: 'none',
            boxShadow: 'none'
          }
        },
        MuiIconButton: {
          root: {
            padding: '6px 6px 7px 6px'
          }
        },
        MuiTypography: {
          body1: {
            color: '#846a6c',
            fontSize: 17
          }
        },
        MuiFormControlLabel: {
          root: {
            marginLeft: '-7px'
          }
        },
        MuiDivider: {
          root: {
            backgroundColor: '#ebebd8'
          }
        }
      }
    });

    return (
      <MuiThemeProvider theme={ theme }>{ this.props.children }</MuiThemeProvider>
    );
  }
}

export default ThemeProvider;



// WEBPACK FOOTER //
// ./src/components/ThemeProvider/ThemeProvider.js